import React from "react";
import { THEME_COLORS } from "../../DarkLight";

function SupportPage() {
  const theme = "light"
  return (
    <div
      style={{
        ...styles.container,
        backgroundColor: THEME_COLORS[theme].full_theme,
        minHeight: "100vh",
        color: THEME_COLORS[theme].inverse_theme,
      }}
    >
      <h1 style={{ ...styles.title, textAlign: "center" }}>Contact Us</h1>
      <p style={{ ...styles.reassurance, textAlign: "center" }}>
        If you have any problems or inquiries, please don't hesitate to{" "}
        <strong>contact us</strong>. We are here to assist you.
      </p>
      <div style={styles.contactInfo}>
        <p>Email: nikiemaadama249@gmail.com</p>
        <p>
          Twitter:{" "}
          <a href="https://twitter.com/JourneyAIapp" style={styles.link}>
            @JourneyAIapp
          </a>
        </p>
        <p>
          Instagram:{" "}
          <a href="https://instagram.com/JourneyAIapp" style={styles.link}>
            @JourneyAIapp
          </a>
        </p>
        <p>Telegram: RichAdams0x</p>
      </div>
      <div style={styles.legalInfo}>
        <h2>Legal Information</h2>
        <p>Copyright © 2024 JourneyAI. All rights reserved.</p>
        <p>
          Please read our{" "}
          <a href="/privacy-policy" style={styles.link}>
            Privacy Policy
          </a>{" "}
          and{" "}
          <a href="/terms-of-service" style={styles.link}>
            Terms of Service
          </a>{" "}
          for more information.
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "800px",
    margin: "auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    borderRadius: "8px",
  },
  reassurance: {
    marginTop: "50px",
    fontSize: "16px",
  },
  title: {},
  contactInfo: {
    marginTop: "30px",
  },
  link: {
    color: "#007bff",
    textDecoration: "none",
  },
  legalInfo: {
    marginTop: "50px",
  },
};

export default SupportPage;
